import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// IMPORTANT: We use createRoot (not hydrateRoot) so React cleanly replaces any
// pre-existing children of #root. This is required because public/index.html
// ships a comprehensive static SEO scaffold inside #root so Google, Bing,
// ChatGPT and Perplexity crawlers can read the full content from the initial
// page source — even when react-snap prerender hasn't run in the deploy
// pipeline. hydrateRoot would attempt to reconcile that scaffold against the
// React tree and throw error #418. createRoot side-steps that entirely.
createRoot(container).render(tree);
